import { Box, Typography } from "@mui/material";
import {ThemeProvider} from '@mui/material/styles'
import theme_one from '../theme.js'

export const P = (props)=>{
	const {children} = props
	return(
		<Typography
			variant="body1"
			component="div"
			textAlign="justify"
			sx={{marginBottom:"20px"}}
		>
			{children}
		</Typography>
	)
}

export const H1 = (props)=>{
	const {children} = props
	return(
		<Typography
			variant="h1"
			component="div"
			textAlign="left"
			sx={{marginBottom:"20px"}}
		>
			{children}
		</Typography>
	)
}

export const Content = (props)=>{
	const {children} = props
	return(
		<ThemeProvider theme={theme_one}>
			<Box
				display="flex"
				flexDirection="column"
				height="87vh"
				sx={{overflowY:"auto", padding:"0px 20px 0px 20px"}}
			>
				{children}
			</Box>
		</ThemeProvider>
	)
}
